export default "__VITE_ASSET__BC6XAR6h__"